import { all, takeLatest, put, takeEvery } from 'redux-saga/effects';
import watchQuestions from './questions/sagas';
import watchTypes from './types/sagas';

import watchAnswers from './answers/sagas';
import {
    CREATE_QUIZ,
    GET_QUIZ,
    GET_ALL_QUIZZES,
    UPDATE_QUIZ,
    DELETE_QUIZ,
    UPDATE_QUIZ_INTRO,
    UPDATE_QUIZ_INTRO_SETTINGS,
    UPDATE_QUIZ_REGISTRATION,
    UPDATE_QUIZ_REGISTRATION_SETTINGS,
    UPDATE_QUIZ_RESULT,
    UPDATE_QUIZ_RESULT_SETTINGS,
    FILTER_QUIZZES,
    DUPLICATE_QUIZ,
    CHANGE_STATUS,
    GET_TENANT_STATISTIC
} from './constants';
import {
    requestQuizCreation,
    requestAllQuizzes,
    requestQuiz,
    requestQuizUpdate,
    requestQuizDelete,
    requestUpdateQuizIntro,
    requestUpdateQuizIntroSettings,
    requestUpdateQuizRegistration,
    requestUpdateQuizRegistrationSettings,
    requestUpdateQuizResult,
    requestUpdateQuizResultSettings,
    requestQuizFilter,
    requestQuizChangeStatus,
    requestGetTenantStatistic,
    requestQuizDuplication
} from './api';
import {
    getAllQuizzesSuccess,
    getQuizSuccess,
    updateQuizSuccess,
    createQuizSuccess,
    deleteQuizSuccess,
    updateQuizIntroSuccess,
    updateQuizIntroSettingsSuccess,
    updateQuizRegistrationSuccess,
    updateQuizRegistrationSettingsSuccess,
    updateQuizResultSuccess,
    updateQuizResultSettingsSuccess,
    updateQuizFilterSuccess,
    changeStatusQuizSuccess,
    getTenantStatisticSuccess,
    duplicateQuizSuccess,
    eraseQuizSuccess
} from './actions';
import { putActionActionBuffer } from '../actionBuffer/actions';

/**
 *
 * @param name
 * @param lang
 * @param quiz_type
 * @param person_type_count
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* createQuiz( { name, lang, quiz_type, person_type_count } ) {
    const quiz = yield requestQuizCreation( { name, lang, quiz_type, person_type_count } );
    if ( quiz ) {
        yield put( createQuizSuccess( quiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* getQuiz( actionObj ) {
    yield put( eraseQuizSuccess() );
    const quiz = yield requestQuiz( actionObj.id, actionObj.resolve );
    if ( quiz ) {
        yield put( getQuizSuccess( quiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{typeQuiz, quizzes, type}>>}
 */
function* getAllQuizzes( actionObj ) {
    const quizzes = yield requestAllQuizzes( actionObj.typeQuiz, actionObj.page, actionObj.tenant, actionObj.search, actionObj.filter );
    if ( quizzes ) {
        yield put( getAllQuizzesSuccess( quizzes, actionObj.typeQuiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, updatedQuizPiece}>>}
 */
function* updateQuiz( actionObj ) {
    const requestObj = {
        [ actionObj.keyName ]: actionObj.updatedQuizPiece
    };
    const isSuccess = yield requestQuizUpdate( requestObj, actionObj.quizID, actionObj.resolve );

    yield put( putActionActionBuffer(
        {
            saveAction: true,
            actionBuff: [
                {
                    'updateQuiz': {
                        'content': actionObj.updatedQuizPiece,
                        type: actionObj.keyName,
                        id: actionObj.quizID
                    }
                }
            ]
        }
    ) );

    if ( isSuccess ) {
        yield put( updateQuizSuccess( isSuccess ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quizID, type}>>}
 */
function* deleteQuiz( actionObj ) {
    const isSuccess = yield requestQuizDelete( actionObj.quizID );
    if ( isSuccess ) {
        yield put( deleteQuizSuccess( actionObj.quizID ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* updateQuizIntro( actionObj ) {
    const quiz = yield requestUpdateQuizIntro( actionObj.quizID, actionObj.intro, actionObj.resolve );
    yield put( putActionActionBuffer( {
        saveAction: true,
        actionBuff: [
            {
                'updateQuizIntro': {
                    id: actionObj.quizID,
                    content: {
                        ...actionObj.intro
                    }
                }
            }
        ]
    } ) );

    if ( quiz ) {
        yield put( updateQuizIntroSuccess( quiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* updateQuizIntroSettings( actionObj ) {
    const quiz = yield requestUpdateQuizIntroSettings( actionObj.quizID, actionObj.introSettings );
    yield put( putActionActionBuffer( {
        saveAction: true,
        actionBuff: [
            {
                'updateQuizIntroSettings': {
                    id: actionObj.quizID,
                    content: {
                        ...actionObj.introSettings
                    }
                }
            }
        ]
    } ) );


    if ( quiz ) {
        yield put( updateQuizIntroSettingsSuccess( quiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* updateQuizRegistrationSettings( actionObj ) {
    const quiz = yield requestUpdateQuizRegistrationSettings( actionObj.quizID, actionObj.registrationSettings );
    yield put( putActionActionBuffer( {
        saveAction: true,
        actionBuff: [
            {
                'updateQuizRegistrationSettings': {
                    id: actionObj.quizID,
                    content: {
                        ...actionObj.registrationSettings
                    }
                }
            }
        ]
    } ) );


    if ( quiz ) {
        yield put( updateQuizRegistrationSettingsSuccess( quiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* updateQuizRegistration( actionObj ) {
    const quiz = yield requestUpdateQuizRegistration( actionObj.quizID, actionObj.registration );
    yield put( putActionActionBuffer( {
        saveAction: true,
        actionBuff: [
            {
                'updateQuizRegistration': {
                    id: actionObj.quizID,
                    content: {
                        ...actionObj.registration
                    }
                }
            }
        ]
    } ) );

    if ( quiz ) {
        yield put( updateQuizRegistrationSuccess( quiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* updateQuizResult( actionObj ) {
    const quiz = yield requestUpdateQuizResult( actionObj.quizID, actionObj.result );

    yield put( putActionActionBuffer( {
        saveAction: true,
        actionBuff: [
            {
                'updateQuizResult': {
                    id: actionObj.quizID,
                    content: {
                        ...actionObj.result
                    }
                }
            }
        ]
    } ) );

    if ( quiz ) {
        yield put( updateQuizResultSuccess( quiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* updateQuizResultSettings( actionObj ) {
    const quiz = yield requestUpdateQuizResultSettings( actionObj.quizID, actionObj.resultSettings );
    yield put( putActionActionBuffer( {
        saveAction: true,
        actionBuff: [
            {
                'updateQuizResultSettings': {
                    id: actionObj.quizID,
                    content: {
                        ...actionObj.resultSettings
                    }
                }
            }
        ]
    } ) );

    if ( quiz ) {
        yield put( updateQuizResultSettingsSuccess( quiz ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, statistics}>>}
 */
function* getTenantStatistic( actionObj ) {
    const statistic = yield requestGetTenantStatistic( actionObj.tenant, actionObj.from, actionObj.to );
    if ( statistic ) {
        yield put( getTenantStatisticSuccess( statistic ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quizzes, type}>>}
 */
function* updateQuizFilter( actionObj ) {
    const quizzes = yield requestQuizFilter( actionObj.typeQuiz, actionObj.page, actionObj.tenant, actionObj.search, actionObj.filter );
    if ( quizzes ) {
        yield put( updateQuizFilterSuccess( quizzes ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* changeStatus( actionObj ) {
    const quizID = yield requestQuizChangeStatus( actionObj.quizID );
    if ( quizID ) {
        yield put( changeStatusQuizSuccess( quizID ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quizess, type}>>}
 */
function* duplicateQuiz( actionObj ) {
    const quizess = yield requestQuizDuplication( actionObj.title, actionObj.lang, actionObj.quizID );
    if ( quizess ) {
        yield put( duplicateQuizSuccess( quizess ) );
    }
}

function* watchQuiz() {
    yield takeLatest( GET_ALL_QUIZZES, getAllQuizzes ),
        yield takeLatest( GET_QUIZ, getQuiz ),
        yield takeLatest( UPDATE_QUIZ, updateQuiz ),
        yield takeLatest( CREATE_QUIZ, createQuiz ),
        yield takeLatest( UPDATE_QUIZ_INTRO, updateQuizIntro ),
        yield takeLatest( UPDATE_QUIZ_INTRO_SETTINGS, updateQuizIntroSettings ),
        yield takeLatest( UPDATE_QUIZ_REGISTRATION, updateQuizRegistration ),
        yield takeLatest( UPDATE_QUIZ_REGISTRATION_SETTINGS, updateQuizRegistrationSettings ),
        yield takeLatest( UPDATE_QUIZ_RESULT, updateQuizResult ),
        yield takeEvery( DELETE_QUIZ, deleteQuiz ),
        yield takeLatest( UPDATE_QUIZ_RESULT_SETTINGS, updateQuizResultSettings ),
        yield takeLatest( FILTER_QUIZZES, updateQuizFilter ),

        yield takeEvery( DUPLICATE_QUIZ, duplicateQuiz ),
        yield takeEvery( CHANGE_STATUS, changeStatus ),
        yield takeLatest( GET_TENANT_STATISTIC, getTenantStatistic );
}


function* quizSaga() {
    yield all( [
        watchQuiz(),
        watchQuestions(),
        watchTypes(),
        watchAnswers()
    ] );
}

export default quizSaga;
